// components/Footer.tsx
import React from "react";
import AnimatedLink from "@/components/ui/animated-link";
import LinkedinIcon from "@/components/atoms/dynamic-icons/linkedin";
import InstaIcon from "@/components/atoms/dynamic-icons/insta";
import EnvelopeIcon from "@/components/atoms/dynamic-icons/envelope";
import Link from "next/link";
import { getMarketplaceUrl } from "@/lib/marketplace-utils";

const Footer: React.FC = () => {
  return (
    <footer className='text-text-title border-border-primmary mx-auto mt-12 w-[90%] border-t-[0.8px] py-5 text-xs font-semibold md:px-5 md:text-sm lg:mt-24'>
      <div className='flex flex-col items-center md:justify-between lg:flex-row'>
        {/* Left Side Links */}
        <div className='mb-4 flex flex-wrap justify-between gap-x-3 md:gap-x-8 md:gap-y-2 lg:mb-0 lg:justify-start'>
          <AnimatedLink
            href={getMarketplaceUrl("/contact")}
            showHoverCircle={false}
            className='hover:text-link-primary text-text-title'
          >
            Contact Us
          </AnimatedLink>
          <AnimatedLink
            href='/#how-will-i-pay'
            showHoverCircle={false}
            className='hover:text-link-primary text-text-title'
          >
            Payment Plans
          </AnimatedLink>
          <AnimatedLink href='/privacy' showHoverCircle={false} className='hover:text-link-primary text-text-title'>
            Privacy and Terms
          </AnimatedLink>
          <AnimatedLink href='/#faq' showHoverCircle={false} className='hover:text-link-primary text-text-title'>
            FAQ
          </AnimatedLink>
        </div>

        {/* Right Side Links and Copyright */}
        <div className='flex flex-wrap justify-center gap-x-4 md:gap-x-8 md:gap-y-2 lg:justify-end'>
          <AnimatedLink
            href='https://vendor.onyxng.com'
            target='_blank'
            rel='noopener noreferrer'
            showHoverCircle={false}
            className='hover:text-link-primary text-text-title'
          >
            Vendor Hub
          </AnimatedLink>
          <AnimatedLink
            href={getMarketplaceUrl("/sales-agent/dashboard")}
            showHoverCircle={false}
            className='hover:text-link-primary text-text-title'
          >
            Sales Agent Portal
          </AnimatedLink>
          <AnimatedLink href='#' showHoverCircle={false} className='hover:text-link-primary text-text-title hidden!'>
            Careers
          </AnimatedLink>
        </div>
      </div>
      <div className='mt-4 flex w-full justify-center'>
        <div className='flex max-w-screen-sm min-w-54 flex-col items-center gap-4'>
          <div className='flex w-full items-center justify-evenly'>
            <Link href='#' className='hidden'>
              <LinkedinIcon className='size-6' />
            </Link>
            <Link
              href='https://www.instagram.com/onyxng_?igsh=MW14dHFicDU1d2lmbA%3D%3D&utm_source=qr'
              target='_blank'
              rel='noopener noreferrer'
            >
              <InstaIcon className='size-6' />
            </Link>
            <Link href='mailto:support@onyxng.com' target='_blank' rel='noopener noreferrer'>
              <EnvelopeIcon className='size-6' />
            </Link>
          </div>
          <div className='flex w-full items-center justify-between'>
            <span className='text-text-title'>© 2026 Onyx</span>
            <Link href='/terms-and-conditions' className='text-text-title'>
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
